import { useRole } from "hooks";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { isAllowed, Roles } from "utils/auth";
import { StyledTabs as Tabs, StyledTab as Tab } from "./styled";
import { StyledGrid } from "components/simple";
interface NavigationProps {
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
}

interface CustomTab {
  label: string;
  to: string;
  value: number;
  role: Roles;
  excludeOrgAdmin?: boolean;
}

const tabs: CustomTab[] = [
  {
    label: "Assessments",
    to: "/assessments?page=1",
    value: 0,
    role: Roles.coach
  },
  {
    label: "Admins",
    to: "/admin-management?page=1",
    value: 1,
    role: Roles.coach,
    excludeOrgAdmin: true
  },
  {
    label: "Users",
    to: "/user-management?page=1",
    value: 2,
    role: Roles.coach
  },
  {
    label: "Organizations",
    to: "/organizations?page=1",
    value: 3,
    role: Roles.coach
  },
  {
    label: "Settings",
    to: "/settings?page=1",
    value: 4,
    role: Roles.admin
  }
];

const pathToHideTabs = [
  "/user-assessments",
  "/assessment/",
  "/internal-notes/",
  "/users/",
  "/organizations/"
];

const Navigation: React.FC<NavigationProps> = ({ setActive }: NavigationProps) => {
  const location = useLocation();
  const role = useRole();
  const fullLocation = location.pathname + location.search;
  const [value, setValue] = useState<number | boolean>(false);
  const tempTab = tabs.find((tab: CustomTab) => tab.to === fullLocation);

  useEffect(() => {
    const isActive = tabs.map(t => t.to.split("?")[0]).includes(location.pathname);
    if (!isActive) {
      setValue(false);
    }
    setActive(isActive);
  }, [location]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number): void => {
    setValue(newValue);
  };
  if (pathToHideTabs.some(p => fullLocation.includes(p))) return null;

  return (
    <StyledGrid item xs={8} maxWidth="1440px">
      <Tabs
        aria-label="navigation tabs"
        onChange={handleChange}
        textColor="inherit"
        value={value}
        variant="fullWidth"
      >
        {tabs
          .filter(x => isAllowed(x.role, role))
          .filter(x => !(x.excludeOrgAdmin && role === Roles.orgAdmin))
          .map((tab: CustomTab) => (
            <Tab component={Link} key={tab.value} label={tab.label} to={tab.to} />
          ))}
      </Tabs>
    </StyledGrid>
  );
};

export default Navigation;
